import { AppFeaturesConstants } from "./constants";

const PLAN_ORDER = [
  AppFeaturesConstants.STARTER,
  AppFeaturesConstants.ESSENTIALS,
  AppFeaturesConstants.ESSENTIALS_PLUS,
];

/**
 * Returns tab ids/masterDataIds allowed for the current subscription.
 * - Subscribed plan: that plan and all lower-tier plans (cumulative).
 * - Free Plan (no subscribed plan): Starter mandatory tabs only.
 * - null when plan details are unavailable (caller should skip filtering).
 */
export const getPlanScopedTabKeys = (planDetails) => {
  if (!Array.isArray(planDetails) || planDetails.length === 0) {
    return null;
  }

  let subscribedPlan = "";
  PLAN_ORDER.forEach((planName) => {
    const match = planDetails.find((plan) => plan?.plan === planName);
    if (match?.subscribed) {
      subscribedPlan = planName;
    }
  });

  const allowedKeys = new Set();
  const addTabKeys = (tabs, { mandatoryOnly = false } = {}) => {
    tabs?.forEach((tab) => {
      if (
        mandatoryOnly &&
        tab?.tabType !== AppFeaturesConstants.MANDATORY_TABS
      ) {
        return;
      }
      if (tab?.id) allowedKeys.add(tab.id);
      if (tab?.masterDataId) allowedKeys.add(tab.masterDataId);
    });
  };

  if (!subscribedPlan) {
    const starterPlan = planDetails.find(
      (plan) => plan?.plan === AppFeaturesConstants.STARTER,
    );
    addTabKeys(starterPlan?.tabs, { mandatoryOnly: true });
    return allowedKeys;
  }

  const subscribedIndex = PLAN_ORDER.indexOf(subscribedPlan);
  planDetails.forEach((plan) => {
    const planIndex = PLAN_ORDER.indexOf(plan?.plan);
    if (planIndex !== -1 && planIndex <= subscribedIndex) {
      addTabKeys(plan?.tabs);
    }
  });

  return allowedKeys;
};

export const filterTabsBySubscriptionPlan = (tabs, planDetails) => {
  if (!Array.isArray(tabs)) return [];

  const allowedKeys = getPlanScopedTabKeys(planDetails);
  if (!allowedKeys) return tabs;

  return tabs.filter(
    (tab) =>
      allowedKeys.has(tab?.id) || allowedKeys.has(tab?.masterDataId),
  );
};
